import styled, { css } from 'styled-components';
import { MediaQuery } from '../../../theme/style-helpers';
import { SummaryContainer } from '../css';

const Container = styled(SummaryContainer)`
    ${MediaQuery.xLarge(css`
        grid-template-columns: 1fr 1fr;
        gap: 32px;
    `)};
`;

export default Container;
